export default "__VITE_ASSET__D3rpS4f4__"